import { Badge, BadgeSize, BadgeVariant, Show } from "shared/components";
import {
  followedUpActionSentence,
  followUpSentenceLower,
  isFollowUpOpen
} from "shared/app/CallFollowUp";
import { formatPhone } from "shared/utils";
import type { LeadActivity } from "views/leads-id/types";

// "Caller needs follow-up: <type>". Only generic labels: the AI may have
// misheard any detail (unit, date, time) the caller gave (AC.3).
export const FollowUpActivityDescription = ({
  activity
}: {
  activity: LeadActivity;
}) => {
  const followUp = activity.metadata.follow_up;
  if (!followUp) return null;

  const open = isFollowUpOpen(followUp);
  const phone = followUp.caller_phone_number;
  const property = followUp.property_name ?? activity.metadata.property_name;

  return (
    <div className="space-y-1.5 text-sm">
      <p className="text-content-700">
        {`Caller ${followUpSentenceLower(followUp)}.`}
      </p>
      <p className="text-content-400">
        <Show if={Boolean(phone)}>
          <span>
            Phone number{" "}
            <span className="text-content-1000">
              {phone ? formatPhone(phone) : ""}
            </span>
          </span>
        </Show>
        <Show if={Boolean(phone) && Boolean(property)}>
          <span className="mx-1.5">·</span>
        </Show>
        <Show if={Boolean(property)}>
          <span className="text-content-1000">{property}</span>
        </Show>
      </p>
      <Show if={!open}>
        <p className="text-content-400">
          Followed up by{" "}
          <span className="text-content-1000">
            {followUp.followed_up_by || "a teammate"}
          </span>
          <span className="mx-1.5">·</span>
          {followedUpActionSentence(followUp)}
        </p>
      </Show>
      <Badge
        variant={open ? BadgeVariant.ERROR : BadgeVariant.SUCCESS}
        size={BadgeSize.SM}
        className="rounded-[16px]"
      >
        {open ? "Open" : "Followed up"}
      </Badge>
    </div>
  );
};
